// source http://emailregex.com/
import { ValidationError } from '../field-validation';

const expr =
  '^(?:[A-Za-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[A-Za-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[A-Za-z0-9-]*[A-Za-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])$';
const emailRegex = new RegExp(expr);

const emailValidatorFn = (control) => {
  if (!!control.value && emailRegex.exec(control.value) === null) {
    return { invalid_email: true };
  }
  return null;
};

export const emailValidatorCodeMapping = {
  invalid_email: {
    severity: 'INVALID',
    message: 'MODEL_DRIVEN_FORM.INVALID_EMAIL_ERROR',
    validationFn: emailValidatorFn,
    asyncValidationFn: null,
  } as ValidationError,
};
